/** 手机布局：工具栏允许换行，手写弹窗限制动态可视高度，避免窄屏和键盘弹出后遮住业务操作。 */
import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { toast } from "../ui/sonner";

const FIELDS = [["payableTo", "支票抬头 Payable to"], ["checkAddress", "支票邮寄地址 Mail to"], ["zelle", "Zelle"], ["bankName", "银行 Bank"], ["accountName", "账户名 Account name"], ["accountNo", "账号 Account No."], ["routingNo", "Routing"], ["email", "财务邮箱"], ["phone", "财务电话"], ["note", "付款页备注"]];
const inp = "mt-0.5 w-full text-sm rounded-md border border-slate-200 px-2.5 py-1.5 focus:outline-none focus:ring-1 focus:ring-slate-400";

/* 财务 / 管理员：客户付款页与 Invoice 上的收款信息。 */
export function RemittanceDialog({ api, zh, onClose }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/crm/signed/remittance").then(({ data }) => setF(data.remittance)).catch((e) => toast.error(e?.detailText || e.message)); }, [api]);
  const save = async () => {
    setBusy(true);
    try { await api.put("/crm/signed/remittance", f); toast.success(zh ? "收款信息已保存" : "Saved"); onClose(true); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <Dialog open onOpenChange={() => onClose(false)}>
      <DialogContent className="max-w-lg" data-testid="remit-dialog">
        <DialogHeader>
          <DialogTitle>{zh ? "客户付款页 · 收款信息" : "Customer pay page · remittance info"}</DialogTitle>
          <DialogDescription>{zh ? "显示在 Invoice PDF 的付款方式与客户付款页上；留空的项不显示。" : "Shown on the invoice PDF and the public pay page; empty fields are hidden."}</DialogDescription>
        </DialogHeader>
        {f && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">
            {FIELDS.map(([k, l]) => (
              <label key={k} className={`block ${k === "note" || k === "checkAddress" ? "sm:col-span-2" : ""}`}><span className="text-[11px] text-slate-500">{l}</span>
                {k === "note" ? <textarea rows={2} className={inp} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`remit-${k}`} /> : <input className={inp} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`remit-${k}`} />}
              </label>
            ))}
          </div>
        )}
        <div className="flex-wrap md:flex-nowrap flex justify-end gap-2 pt-1">
          <Button variant="outline" size="sm" onClick={() => onClose(false)} data-testid="remit-cancel">{zh ? "取消" : "Cancel"}</Button>
          <Button size="sm" disabled={busy || !f} onClick={save} className="bg-slate-900 text-white" data-testid="remit-save">{zh ? "保存" : "Save"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
